import { hasAnalyticsConsent } from "./consent";

const GA_MEASUREMENT_ID = "G-HRD1Y1B3YH";

let initialized = false;

// Lädt das gtag.js Script dynamisch ins DOM – nur einmal
const loadGoogleScript = () => {
    return new Promise((resolve) => {
        if (document.querySelector(`script[src*="${GA_MEASUREMENT_ID}"]`)) {
            resolve();
            return;
        }

        // gtag dataLayer initialisieren bevor das Script geladen wird
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        window.gtag("js", new Date());
        window.gtag("config", GA_MEASUREMENT_ID, {
            anonymize_ip: true,       // DSGVO: IP anonymisieren (bei GA4 Standard, aber explizit besser)
            send_page_view: true,
        });

        const script = document.createElement("script");
        script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
        script.async = true;
        script.onload = resolve;
        document.head.appendChild(script);
    });
};

export const initializeAnalytics = async () => {
    if (!hasAnalyticsConsent()) return;
    if (initialized) return;

    initialized = true;

    await loadGoogleScript();
};

// Wird aufgerufen wenn User Consent widerruft
// initialized zurücksetzen damit nach erneutem Accept GA neu startet
export const disableAnalytics = () => {
    initialized = false;
    window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
};

export const trackEvent = (eventName, params = {}) => {
    if (!hasAnalyticsConsent()) return;

    if (window.gtag) {
        window.gtag("event", eventName, params);
    }
};